import { DiaSemanaEnum } from 'graphql/types.generated'

export const abreviarDiaSemana = (diaSemanaEnum: DiaSemanaEnum) =>
  diaSemanaEnum === DiaSemanaEnum.SABADO ? 'SÁB' : diaSemanaEnum.slice(0, 3)
